import { Flex, Graph, IRenderControl, RenderControl, Span } from '@fareye/ui'
import { cancelToken, get, isEmpty, responseParser } from '@fareye/utils'
import React from 'react'
import { haversineDistance } from '../../../utility/function'
import { PingInfoType } from '../../../utility/types'

let add = (arr: any[]) =>
  arr.reduce(function(a, b) {
    return a + b
  }, 0)

const initialState: IRenderControl = {
  data: null,
  isLoading: false,
  isSuccess: true,
  isError: false,
  message: ''
}
export const DailyDistanceGraph = ({
  slug,
  histories,
  apiBased = true,
}: {
  slug: string
  histories: PingInfoType[]
  apiBased?: boolean
}) => {
  const [graphData, setGraphData] = React.useState<IRenderControl>(initialState)
  let source = cancelToken().source()

  React.useEffect(() => {
    if (apiBased) {
      fetchData()
    } else {
      createChartFromHistory()
    }

    return () => source.cancel('')
  }, [apiBased])

  function findDistance(data: any) {
    return add(
      data.map((item: any) => {
        return Number(item.distanceTravelled)
      })
    ).toFixed(2)
  }

  async function createChartFromHistory() {
    let res: any = {}
    histories.forEach(x => {
      const dat = x.istTimestamp.toString().split('T')[0]
      if (!res[dat]) {
        res[dat] = [x]
      } else {
        res[dat].push(x)
      }
    })

    let result: any = {}
    Object.entries(res).forEach(([key, arr]: any) => {
      result[key] = add(
        arr.map((item: PingInfoType, index: number, arr: PingInfoType[]) => {
          if (index !== 0) {
            return haversineDistance(
              [arr[index - 1].latitude, arr[index - 1].longitude],
              [item.latitude, item.longitude]
            )
          } else {
            return 0
          }
        })
      )
    })
    const data = Object.entries(result).map(([date, km], index) => ({
      distanceTravelled: (km as any).toFixed(2),
      date: new Date(date).toISOString(),
      id: index
    }))
    setGraphData({
      data,
      isLoading: false,
      isSuccess: true,
      isError: false,
      message: ''
    })
  }

  async function fetchData() {
    try {
      setGraphData({ ...graphData, isLoading: true })
      let url = `/api/v1/consigner/track/${slug}/daily_trip_info`
      let { data } = await get(url, source.token, {
        headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
      })
      setGraphData({
        data: data.dailyTripInfo,
        isLoading: false,
        isError: false,
        isSuccess: true,
        message: isEmpty(data.dailyTripInfo) ? 'No Data Found' : ''
      })
    } catch (ex:any) {
      const { message } = responseParser(ex)
      setGraphData({
        ...graphData,
        isLoading: false,
        isError: true,
        isSuccess: false,
        message: message || 'Something Went wrong...'
      })
    }
  }

  return (
    <Flex column>
      <Span p={4} style={{ color: '#727272' }}>
        Distance Travelled per day
      </Span>
      <div id="distanceCovered" style={{ width: '90%', margin: '0 auto' }}>
        <RenderControl state={graphData}>
          <Graph
            config={{
              colors: {},
              legendsList: [''],
              xAxisUnit: 'date',
              yAxisUnit: 'number'
            }}
            type="bar"
            ratio={1.3}
            XLabelKey={'date'}
            XLabel={'Date'}
            YLabel={'Distance Travelled (Km)'}
            data={graphData.data}
            selector="distanceCovered"
            YLabelKey={['distanceTravelled']}
          />
        </RenderControl>
      </div>
    </Flex>
  )
}
